<template>
  <div>
    <NavigationBar
      titel="Neuen Dienstgrad anlegen"
      showBackBtn
      :actions="actions"
    ></NavigationBar>
    <section>
      <v-form
        v-model="helpers.formIsValid"
        ref="form"
        @submit.prevent="createItem"
      >
        <rank-editor v-model="rank" mode="new"></rank-editor>
      </v-form>
    </section>
  </div>
</template>

<script>
import { MEMBER_MANAGEMENT } from "@/store/modules.js";
import { CREATE_RANK } from "@/store/action-types.js";
import NavigationBar from "@/components/_systemwide/NavigationBar.vue";
import RankEditor from "@/components/member-management/ranks/RankEditor.vue";

export default {
  name: "member-management-rank-new",
  components: {
    NavigationBar,
    RankEditor,
  },
  data() {
    return {
      actions: [
        {
          title: "Speichern",
          icon: "mdi-content-save",
          actionStyle: "textBtnSubmit",
          function: this.createItem,
        },
      ],

      helpers: {
        formIsValid: false,
      },
      rank: {
        title: "",
        shortTitle: "",
        sortKey: null,
        isActive: true,
      },
    };
  },

  methods: {
    createItem() {
      this.$refs.form.validate();
      if (this.helpers.formIsValid) {
        this.$store.dispatch(`${MEMBER_MANAGEMENT}${CREATE_RANK}`, {
          organizationId: this.$route.params.organizationId,
          title: this.rank.title,
          shortTitle: this.rank.shortTitle,
          sortKey: this.rank.sortKey,
          isActive: this.rank.isActive,
        });
      } else {
        alert("Prüfen Deine Eingabe und versuchen es erneut.");
      }
    },
  },
};
</script>

<style></style>
